<template>
  <footer>
    <div class="width1394 top d-flex d-flex-aifs d-flex-jc-sb">
      <div class="top-left">
        <img :src="require('@/assets/images/footer-logo.png')" alt="" />
        <p>专业的企业级大数据解决方案服务商</p>
        <img :src="require('@/assets/images/ewm1.png')" alt="" class="ewm" />
        <img :src="require('@/assets/images/ewm2.png')" alt="" />
      </div>
      <div class="top-right d-flex d-flex-aifs d-flex-jc-sb">
        <dl>
          <dt>站点导航</dt>
          <dd v-for="(item, index) in navs" :key="index">
            <router-link :to="item.to">
              <img
                  :src="require('@/assets/images/footer-icon.png')"
                  alt=""
                  class="ewm"
              />
              {{ item.name }}
            </router-link>
          </dd>
        </dl>
        <dl>
          <dt>联系我们</dt>
          <dd v-for="(item, index) in contacts" :key="index">
            <img
                :src="require('@/assets/images/footer-icon.png')"
                alt=""
                class="ewm"
            />
            {{ item.name }}：{{ item.value }}
          </dd>
        </dl>
      </div>
    </div>
    <div class="bottom">
      <div class="width1394 d-flex d-flex-aic d-flex-jc-sb d-flex-fw-w">
        <span>© 2017-2025 dobel.cn 版权所有</span>
        <a href="">广州多贝网络科技有限公司</a>
        <span>增值电信业务许可证B1-20224298</span>
        <a href="https://beian.miit.gov.cn" target="_blank">粤ICP备13029860号</a>
        <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602006837" target="_blank">
          <img src="@/assets/images/ba.png" alt="">
          粤公网安备44010602006837号
        </a>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      navs: [
        { name: '首页', to: '/', },
        { name: 'HTTP隧道代理', to: '/proxyhttp', },
        // { name: '超级HTTP隧道代理', to: '/superhttp', },
        { name: '家宽短效代理', to: '/proxysmall', },
        { name: '家宽长效代理', to: '/proxylong', },
        { name: '静态IP代理', to: '/proxyip', },
      ],
      contacts: [
        { name: '地址', value: '广州市天河区建中路16号203' },
        { name: '联系电话', value: '020-34794382' },
        { name: '邮箱', value: 'sales@dobel.cn' },
        { name: 'QQ', value: '395580691' },
      ],
    }
  },
}
</script>
<style lang="less" scoped>
footer {
  background: #0c3063;
  .top {
    padding: 120px 0 60px;
    .top-left {
      margin-left: 44px;
      width: 310px;
      p {
        font-size: 18px;
        color: #fff;
        margin: 18px 0 66px;
      }
      .ewm {
        margin-right: 28px;
      }
    }
    .top-right {
      width: 718px;
      dt {
        font-size: 22px;
        color: #fff;
        margin-bottom: 10px;
      }
      dd {
        margin-top: 26px;
        font-size: 16px;
        color: #ccd1d5;
        a {
          font-size: 16px;
          color: #ccd1d5;
          &:hover {
            color: #2e56c7;
          }
        }
      }
    }
  }
  .bottom {
    border-top: 1px solid #ccd1d5;
    line-height: 68px;
    a,
    span {
      font-size: 18px;
      color: #fff;
    }
    a {
      &:hover {
        color: #2e56c7;
      }
    }
  }
}
@media (max-width: 1394px) {
  footer .top .top-left {
    margin-left: 0;
    width: 40%;
  }
  footer .top .top-right {
    margin-left: 0;
    width: 55%;
  }
  footer .bottom a,
  footer .bottom span {
    font-size: 14px;
  }
}
@media (max-width: 1024px) {
  footer .bottom {
    padding-top: 1%;
  }
  footer .bottom .width1394 span,
  footer .bottom .width1394 a {
    width: 33.33%;
    text-align: center;
    line-height: 32px;
  }
}
@media (max-width: 768px) {
  footer .top {
    padding: 6% 0 2%;
    flex-direction: column;
  }
  footer .top .top-left,
  footer .top .top-right {
    width: 100%;
  }
  footer .top .top-left {
    text-align: center;
  }
  footer .top .top-left p {
    font-size: 14px;
  }
  footer .top .top-right {
    margin-top: 2%;
    flex-direction: column;
  }
  footer .top .top-right dl {
    width: 100%;
  }
  footer .top .top-right dl dt {
    font-size: 18px;
    margin-bottom: 0;
    text-align: center;
  }
  footer .top .top-right dl dd {
    margin-top: 10px;
    font-size: 14px;
  }
  footer .bottom .width1394 {
    flex-direction: column;
  }
  footer .bottom .width1394 span,
  footer .bottom .width1394 a {
    width: 100%;
    font-size: 12px;
    line-height: 24px;
  }
}
</style>
